<template>
	<div class="container" ref="img_box_extended_container">
		<h3 v-if="item.show_title" class="mb-3">{{ item.title }}</h3>

		<div class="row" :class="{[`justify-content-${item.data.position}`]: true, 'd-none': parseInt(index)+1 > rowsLimit}" v-for="index in Object.keys(chunkedItems)">
			<div v-for="image in chunkedItems[index]" :class="`col-xl-${item.data.grid_size}`" class="col-lg-4 col-md-6 col-12 mb-4">
				<div class="image-box-extended" :class="{'image-box-extended--zoom': image.hover === 'zoom', 'image-box-extended--blur': image.hover === 'blur'}">
					<div class="image-box-extended__img">
						<seo-image :data="image.background" />
						<div class="image-box-extended__img-overlay" :class="{[`text-${image.text_align}`]: true, 'image-box-extended__img-overlay--top': image.text_position === 'on_image_top', 'image-box-extended__img-overlay--center': image.text_position === 'on_image_center'}" v-if="image.text_position.startsWith('on_image')" v-html="image.content">
						</div>
					</div>
					<div v-html="image.content" class="image-box-extended__content" :class="{'order-first': image.text_position === 'top_image', [`text-${image.text_align}`]: true}" v-if="!image.text_position.startsWith('on_image')">
					</div>
					<a v-if="image.link" :href="image.link" :target="image.link_operation === 'blank' ? '_blank' : ''" class="stretched-link"></a>
				</div>
			</div>
		</div>

		<div class="row" v-if="showButton">
			<div class="col-12">
				<button-unit
					@click-on-btn="showAll"
					ref="show_btn"
					class="mx-auto"
					:options="{
						shape: ButtonUnitShape.ROUNDED,
						text: translate('image-box-extended-button'),
						bgColor: `var(--color-header-button-bg)`,
						textColor: `var(--color-header-button-text)`,
					}"
				/>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import SeoImage from "../../../Components/SeoImage.vue";
import { ButtonUnitShape } from "../../../Components/Units/Interfaces/ButtonUnitShape";
import ButtonUnit from "../../../Components/Units/ButtonUnit.vue";

export default defineComponent({
	name: "ImageBoxExtendedPageSection",
	components: {
		SeoImage,
		ButtonUnit,
	},
	props: {
		item: {
			type: Object,
			required: true,
			default: {}
		}
	},
	computed: {
		chunkedItems() {
			let result = [];
			for (let i = 0; i < this.item.data.images.length; i += parseInt(this.item.data.quantity)) {
				result.push(this.item.data.images.slice(i, i + parseInt(this.item.data.quantity)));
			}
			return result;
		},
		rowsLimit() {
			return parseInt(this.item.data.rows_limit);
		},
		showButton() {
			return this.chunkedItems.length > this.rowsLimit;
		},
		ButtonUnitShape() {
			return ButtonUnitShape;
		}
	},
	methods: {
		showAll() {
			const container = this.$refs.img_box_extended_container;
			container.querySelectorAll('.row.d-none').forEach(el => el.classList.remove('d-none'));
			container.querySelector('button').classList.add('d-none');
		}
	}
});
</script>